import type { FaireProductEntity } from "../../entity_types/product";

export const p_mb7pz63w34: FaireProductEntity = {
  token: "p_mb7pz63w34",
  type: "product",
  name: "anxiety ease | therapeutic roller",
  brandName: "Set Apart Studio",
  imageUrl:
    "https://cdn.faire.com/fastly/7526eb2216d917fb1bf9e627143b1f18c86fe518119fc5e0b9ebb796e38ad7f9.jpeg",
  priceDollars: 7.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/7ecfd2970528396ecea07283e42a0ab08588246f7cf6688ff449faaf7962c57f.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
